<template src="./side.bar.html"></template>
<style src="@/shared/global.css"></style>

<script>
import myMixin from "@/helpers/mixins.js";

export default {
  data() {
    return {
      responsive: false,
      isCollapse: true,
      sbIcon: "el-icon-caret-right",
      sideBarWidth: "230px",
      allPermissions: [],
      showCommerce: true,
      showMonitoring: true,
      showDelivery: true,
      showRol: true,
      showuser: true,
      showZone: true,
      showTypeCommerce: true,
      showtypeDocument: true,
      showCity: true,
      showCountry: true,
      showTypeInvoice: true,
      showAccountBank: true,
      showIvaRegime: true,
      showBanks: true,
      showTypeVehicle: true,
      showMeshes: true,
      showPaymentMethod: true,
      showHolidays: true,
      showInformes: true,
    };
  },
  mixins: [myMixin],
  mounted() {
    window.addEventListener("resize", this.checkForResponsive);
    this.checkForResponsive();

    const user = this.$store.state.authData;
    const rol = user.roles[0];

    const isSuperAdmin = rol.name === "Super Administrador";
    const isClient = rol.name === "Cliente";
    const isPointSale = rol.name === "Punto de venta";
    const isSeleccion = rol.name === "Selección";

    console.log({ isSuperAdmin, isClient, isPointSale, isSeleccion });

    this.showCommerce = isSuperAdmin || isSeleccion || isClient;
    this.showMonitoring = isSuperAdmin || isClient;
    this.showDelivery = isSuperAdmin || isSeleccion || isClient;
    this.showRol = isSuperAdmin;
    this.showuser = isSuperAdmin;
    this.showZone = isSuperAdmin || isSeleccion;
    this.showTypeCommerce = isSuperAdmin;
    this.showtypeDocument = isSuperAdmin;
    this.showCity = isSuperAdmin;
    this.showCountry = isSuperAdmin;
    this.showTypeInvoice = isSuperAdmin;
    this.showAccountBank = isSuperAdmin;
    this.showIvaRegime = isSuperAdmin;
    this.showBanks = isSuperAdmin;
    this.showTypeVehicle = isSuperAdmin;
    this.showMeshes = isSuperAdmin || isClient;
    this.showPaymentMethod = isSuperAdmin;
    this.showHolidays = isSuperAdmin;
    this.showInformes = isSuperAdmin || isPointSale;
  },
  props: {
    modehv: String,
  },
  methods: {
    showItemInMenu(permissions) {
      //devuelve true en caso de que el permiso
      return permissions != undefined
        ? permissions.permissions[0] == 1
          ? true
          : false
        : false;
    },
    findPermisssion(name) {
      //Busca un permiso por el nombre
      let permission = this.allPermissions.find((item) => item.name == name);
      return permission;
    },
    checkForResponsive() {
      let w = window.innerWidth;
      if (w <= 768) {
        this.isCollapse = false;
        this.responsive = true;
      } else {
        this.isCollapse = true;
        this.responsive = false;
      }
      this.$store.commit("toggleMenu", { data: true });
    },
    handleOpen(key, keyPath) {
      //console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      //console.log(key, keyPath);
    },
    Logout() {
      this.$store.commit("login", { isLogin: false });
    },
    toggleSbMenu: function () {
      this.isCollapse = !this.isCollapse;
      this.sbIcon =
        this.sbIcon == "el-icon-caret-right"
          ? "el-icon-caret-left"
          : "el-icon-caret-right";
      this.sideBarWidth = this.sideBarWidth == "230px" ? "63px" : "230px";
      this.$store.commit("toggleMenu", { data: this.isCollapse });
    },
  },
};
</script>

<style src="./side.bar.css"></style>
